module.exports = __webpack_public_path__ + "img/slider2.5f34a0b9.jpg";